var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFavorite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.833252C8.19031 0.833252 8.36412 0.941288 8.44836 1.11194L10.3921 5.04982L14.739 5.68518C14.9273 5.7127 15.0836 5.8447 15.1423 6.0257C15.201 6.20671 15.1518 6.40533 15.0155 6.5381L11.8706 9.60127L12.6128 13.9287C12.645 14.1163 12.5679 14.3059 12.4139 14.4178C12.2599 14.5296 12.0557 14.5444 11.8873 14.4558L8 12.4115L4.11273 14.4558C3.94427 14.5444 3.74012 14.5296 3.58613 14.4178C3.43215 14.3059 3.35502 14.1163 3.3872 13.9287L4.12941 9.60127L0.984469 6.5381C0.84816 6.40533 0.799023 6.20671 0.857712 6.0257C0.916401 5.8447 1.07274 5.7127 1.26102 5.68518L5.60787 5.04982L7.55165 1.11194C7.63588 0.941288 7.80969 0.833252 8 0.833252ZM8 2.46288L6.38836 5.7279C6.31559 5.87532 6.17499 5.97755 6.01232 6.00133L2.40754 6.52822L5.01553 9.06841C5.13347 9.18328 5.1873 9.34884 5.15947 9.51111L4.54409 13.0991L7.76728 11.404C7.91297 11.3274 8.08704 11.3274 8.23273 11.404L11.4559 13.0991L10.8405 9.51111C10.8127 9.34884 10.8665 9.18328 10.9845 9.06841L13.5925 6.52822L9.98769 6.00133C9.82501 5.97755 9.68442 5.87532 9.61165 5.7279L8 2.46288Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavorite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/favorite.79b2e2b6.svg";
export { ForwardRef as ReactComponent };